import { useMemo } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import EventsPage from "./pages/EventsPage";
import EventDetailPage from "./pages/EventDetailPage";
import MeetTheTeamPage from "./pages/MeetTheTeamPage";
import JoinWaitlistPage from "./pages/JoinWaitlistPage";
import UpdatesPage from "./pages/UpdatesPage";
import VenuesPage from "./pages/VenuesPage";
import GuestListPage from "./pages/GuestListPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import MyTicketsPage from "./pages/MyTicketsPage";
import AdminDashboard from "./pages/AdminDashboard";
import PromoterDashboard from "./pages/PromoterDashboard";
import OrganizerDashboard from "./pages/OrganizerDashboard";
import ScanPage from "./pages/ScanPage";
import DiscoveryPage from "./pages/DiscoveryPage";
import ProfilePage from "./pages/ProfilePage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import RsvpPage from "./pages/RsvpPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import GlobalNavbar from "./components/GlobalNavbar";
import Footer from "./components/Footer";
import MetaPixelRouteTracker from "./components/MetaPixelRouteTracker";
import PromotionPopup from "./components/PromotionPopup";
import { CartProvider } from "./context/CartContext";
import "./App.css";

// Memoized toast options to prevent re-renders
const toastOptions = {
  style: {
    background: '#0A0A0A',
    border: '1px solid #27272A',
    color: '#ffffff',
    fontFamily: 'Inter, sans-serif',
  },
};

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <CartProvider>
        <BrowserRouter>
        <MetaPixelRouteTracker />
        <div className="App min-h-screen bg-[#050505]">
          {/* Noise overlay */}
          <div className="noise-overlay" />
          
          <GlobalNavbar />
          <PromotionPopup />
          
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/events/:id" element={<EventDetailPage />} />
            <Route path="/team" element={<MeetTheTeamPage />} />
            <Route path="/waitlist" element={<JoinWaitlistPage />} />
            <Route path="/updates" element={<UpdatesPage />} />
            <Route path="/venues" element={<VenuesPage />} />
            <Route path="/guestlist" element={<GuestListPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/my-tickets" element={<MyTicketsPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/promoter" element={<PromoterDashboard />} />
            <Route path="/organizer" element={<OrganizerDashboard />} />
            <Route path="/scan" element={<ScanPage />} />
            <Route path="/discovery" element={<DiscoveryPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/rsvp/:code" element={<RsvpPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>

          <Footer />
          
          <Toaster 
            position="bottom-right"
            toastOptions={toastOptions}
          />
        </div>
      </BrowserRouter>
      </CartProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
